var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEolasTitle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 222,
    height: 58,
    viewBox: "0 0 222 58",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9495_138227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8181 28.5526L20.2986 23.0809L23.6216 19.7867L21.808 17.9777C17.6176 13.9576 17.5163 7.33578 21.5602 3.18175C25.6041 -0.97227 32.2952 -1.08394 36.4855 2.93609C40.6759 6.95611 40.7773 13.578 36.7334 17.732C36.6545 17.8102 36.5757 17.8995 36.4855 17.9777L25.8181 28.5526ZM29.1524 7.73778C27.6317 7.73778 26.4039 8.95495 26.4039 10.4625C26.4039 11.1995 26.708 11.9141 27.2487 12.4278L27.305 12.4836L29.1524 14.315L31.0561 12.4278C32.1487 11.3893 32.1825 9.65846 31.1349 8.57528C30.6168 8.03928 29.8959 7.73778 29.1524 7.73778Z",
    fill: "url(#paint0_linear_9495_138227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.305 12.4834L27.2487 12.4275C26.708 11.9139 26.4039 11.2104 26.4039 10.4622C26.4039 10.317 26.4151 10.183 26.4376 10.0378L19.4762 6.27466C17.719 10.2723 18.6427 14.94 21.808 17.9662L23.6328 19.7752L29.1524 14.3035L27.305 12.4834Z",
    fill: "url(#paint1_linear_9495_138227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7073 10.4621C39.7185 13.2985 38.5583 16.012 36.4969 17.9773L25.8295 28.5522L20.3099 23.0805L29.1525 14.3146L31.0562 12.4275C32.1488 11.389 32.1826 9.66929 31.135 8.57495C31.0787 8.51912 31.0337 8.47445 30.9773 8.41862L34.1877 1.26074C37.5783 3.10325 39.696 6.63194 39.7073 10.4621Z",
    fill: "url(#paint2_linear_9495_138227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6143 25.5829L35.1338 20.1112L38.6145 23.5617L40.4394 21.7527C44.4946 17.5986 51.1744 17.4981 55.3647 21.507C59.5551 25.5159 59.6677 32.1489 55.6126 36.3029C51.5574 40.4569 44.8776 40.5574 40.6872 36.5486C40.6083 36.4704 40.5182 36.3923 40.4394 36.3029L29.6143 25.5829ZM50.7689 29.0334C50.7689 27.5259 49.5298 26.3087 48.0091 26.3087C47.2656 26.3087 46.556 26.6102 46.0378 27.1462L45.9815 27.202L44.1341 29.0334L46.0378 30.9206C47.0854 32.0037 48.8314 32.0372 49.924 30.9987C50.4647 30.4851 50.7689 29.7704 50.7689 29.0334Z",
    fill: "url(#paint3_linear_9495_138227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9702 27.1792L46.0265 27.1234C46.5447 26.5874 47.2656 26.2858 48.0091 26.2858C48.1555 26.2858 48.2907 26.297 48.4371 26.3193L52.2332 19.4295C48.2006 17.6875 43.492 18.6031 40.4394 21.741L38.6258 23.5388L44.1454 29.0105L45.9702 27.1792Z",
    fill: "url(#paint4_linear_9495_138227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0204 39.4959C45.1593 39.507 42.422 38.3569 40.4395 36.3133L29.6256 25.5933L35.1452 20.1216L44.1455 29.0438L46.0491 30.9198C47.0967 32.003 48.8315 32.0365 49.9354 30.998C49.9917 30.9421 50.0368 30.8975 50.0931 30.8416L57.3136 34.0242C55.4437 37.3965 51.8841 39.4847 48.0204 39.4959Z",
    fill: "url(#paint5_linear_9495_138227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6557 29.4458L38.1752 34.9175L34.8522 38.2117L36.6771 40.0207C40.8674 44.0407 40.9688 50.6626 36.9249 54.8166C32.8809 58.9706 26.1786 59.0711 21.9882 55.0511C17.7979 51.0311 17.6965 44.4092 21.7404 40.2664C21.8193 40.1882 21.8981 40.0989 21.9882 40.0207L32.6557 29.4458ZM29.3326 50.2606C30.8533 50.2606 32.0812 49.0434 32.0812 47.5359C32.0812 46.7989 31.777 46.0842 31.2363 45.5706L31.18 45.5147L29.3326 43.6834L27.429 45.5706C26.3363 46.6091 26.3025 48.3399 27.3501 49.4231C27.8683 49.9591 28.5779 50.2606 29.3326 50.2606Z",
    fill: "url(#paint6_linear_9495_138227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2026 45.5148L31.2589 45.5706C31.7996 46.0843 32.1037 46.799 32.1037 47.536C32.1037 47.6811 32.0925 47.8151 32.0699 47.9603L39.0201 51.7235C40.7773 47.7258 39.8536 43.0581 36.6883 40.0319L34.8635 38.2229L29.3439 43.6946L31.2026 45.5148Z",
    fill: "url(#paint7_linear_9495_138227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7779 47.5359C18.7666 44.6996 19.9268 41.986 21.9882 40.0207L32.6556 29.4458L38.1752 34.9175L29.3326 43.6834L27.4289 45.5706C26.3363 46.6091 26.2912 48.3287 27.3501 49.4231C27.4064 49.4789 27.4515 49.5236 27.5078 49.5794L24.2862 56.7261C20.8956 54.8948 18.7779 51.3661 18.7779 47.5359Z",
    fill: "url(#paint8_linear_9495_138227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8934 32.3824L23.3738 37.854L19.9607 34.4705L18.1358 36.2795C14.0806 40.4224 7.40084 40.5341 3.21047 36.514C-0.979894 32.494 -1.08127 25.8721 2.96266 21.7293C7.00658 17.5864 13.6977 17.4748 17.8768 21.4836C17.9556 21.5618 18.0345 21.64 18.1246 21.7293L28.8934 32.3824ZM7.80636 28.9988C7.80636 30.5063 9.03418 31.7235 10.5549 31.7235C11.2983 31.7235 12.0193 31.422 12.5374 30.886L12.5937 30.8302L14.4411 28.9988L12.5374 27.1117C11.4898 26.0285 9.74384 25.995 8.65119 27.0335C8.1105 27.5472 7.80636 28.2507 7.80636 28.9988Z",
    fill: "url(#paint9_linear_9495_138227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6501 30.8528L12.5938 30.9086C12.0756 31.4446 11.366 31.7461 10.6112 31.7461C10.4648 31.7461 10.3296 31.7349 10.1832 31.7126L6.38708 38.6025C10.4197 40.3445 15.1283 39.4288 18.1809 36.291L20.0058 34.482L14.4862 29.0103L12.6501 30.8528Z",
    fill: "url(#paint10_linear_9495_138227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5548 18.5357C13.416 18.5246 16.1532 19.6747 18.1358 21.7182L28.8933 32.3825L23.3737 37.8542L14.441 28.999L12.5373 27.1118C11.4897 26.0286 9.75503 25.9839 8.65111 27.0336C8.59479 27.0894 8.54973 27.1341 8.49341 27.1899L1.28418 24.0074C3.13155 20.6351 6.67984 18.5357 10.5548 18.5357Z",
    fill: "url(#paint11_linear_9495_138227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.63 5.08099L93.7764 5.18149C93.9116 4.96932 94.058 4.76832 94.2045 4.55615C93.9792 4.70132 93.7426 4.84649 93.5173 4.99165C93.5511 5.02516 93.5849 5.05866 93.63 5.08099Z",
    fill: "url(#paint12_linear_9495_138227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6937 29.9825C87.3332 30.3175 86.8601 30.4961 86.3757 30.4738H71.1687C71.4616 32.3275 72.3064 33.8238 73.7145 34.9517C75.1226 36.0795 76.8347 36.6602 78.8623 36.6602C79.7184 36.649 80.5633 36.5038 81.363 36.2247C82.129 35.9902 82.8499 35.6217 83.5033 35.1527C83.875 34.8623 84.3481 34.706 84.8212 34.7172C85.3281 34.7172 85.7224 34.8512 86.0265 35.1192C86.5109 35.51 86.7474 35.9678 86.7474 36.4703C86.7474 36.9505 86.5334 37.3413 86.1054 37.654C85.2042 38.3687 84.0778 38.9493 82.726 39.396C81.487 39.8315 80.1803 40.0549 78.8623 40.066C76.677 40.066 74.717 39.597 72.9823 38.659C71.2927 37.7545 69.8846 36.4033 68.9159 34.7507C67.9358 33.0868 67.4515 31.1885 67.4515 29.078C67.4515 26.9674 67.9133 25.0691 68.837 23.3829C69.7156 21.7414 71.0561 20.3902 72.6782 19.4634C74.3228 18.5254 76.1814 18.0564 78.2653 18.0564C80.3155 18.0564 82.0952 18.5031 83.5821 19.4076C85.069 20.3009 86.2743 21.6186 87.0178 23.1819C87.8176 24.7899 88.2231 26.6436 88.2231 28.7318C88.2231 29.212 88.0316 29.6586 87.6937 29.9825ZM73.5005 23.0591C72.2839 24.1199 71.5179 25.5269 71.2025 27.3024H84.5284C84.2918 25.5269 83.6159 24.1199 82.5233 23.0591C81.4306 21.9983 80 21.4734 78.2428 21.4734C76.2941 21.4734 74.717 22.0094 73.5005 23.0591Z",
    fill: "url(#paint13_linear_9495_138227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.853 38.8491C109.197 37.9446 107.846 36.5823 106.933 34.9408C105.998 33.2769 105.525 31.3786 105.536 29.2681C105.536 27.1241 106.009 25.2257 106.933 23.5507C107.846 21.9092 109.197 20.5469 110.853 19.6424C112.532 18.7044 114.435 18.2354 116.576 18.2354C118.682 18.2354 120.574 18.7044 122.242 19.6424C123.886 20.558 125.249 21.9092 126.162 23.5507C127.108 25.2146 127.581 27.1241 127.581 29.2681C127.581 31.3898 127.119 33.2769 126.184 34.9408C125.272 36.5823 123.92 37.9335 122.287 38.8491C120.619 39.7871 118.716 40.2561 116.587 40.2561C114.447 40.2561 112.543 39.7871 110.853 38.8491ZM120.248 35.7336C121.318 35.1083 122.196 34.1926 122.771 33.0983C123.368 31.9704 123.672 30.6974 123.672 29.2681C123.672 27.8387 123.368 26.5546 122.771 25.4156C122.196 24.3101 121.329 23.3944 120.248 22.7579C117.972 21.4849 115.201 21.4849 112.926 22.7579C111.844 23.3944 110.966 24.3101 110.38 25.4156C109.761 26.5546 109.456 27.8387 109.456 29.2681C109.456 30.6974 109.761 31.9704 110.38 33.0983C110.966 34.1926 111.844 35.1083 112.926 35.7336C115.19 37.0066 117.972 37.0066 120.248 35.7336Z",
    fill: "url(#paint14_linear_9495_138227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.708 39.0727C145.784 38.4474 145.075 37.5764 144.568 36.4485C144.061 35.3207 143.813 34.0589 143.802 32.663V10.9996C143.779 9.90523 144.646 9.00072 145.75 8.96722C146.854 8.94489 147.767 9.80473 147.801 10.8991C147.801 10.9326 147.801 10.9661 147.801 10.9884V32.6519C147.801 33.6345 147.992 34.4385 148.364 35.075C148.735 35.7115 149.22 36.0242 149.806 36.0242H150.808C151.304 36.013 151.777 36.214 152.115 36.5825C152.453 36.951 152.61 37.4312 152.61 38.0119C152.61 38.5926 152.363 39.0727 151.844 39.4412C151.326 39.8097 150.684 39.9996 149.884 39.9996H149.794C148.702 40.0219 147.62 39.6981 146.708 39.0727Z",
    fill: "url(#paint15_linear_9495_138227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.484 19.5199C184.14 20.4691 185.503 21.8426 186.449 23.4841C187.429 25.1591 187.913 27.0351 187.913 29.1009V37.945C187.913 39.0617 187.001 39.9662 185.874 39.9662C184.748 39.9662 183.835 39.0617 183.835 37.945V36.471C180.659 40.2677 175.151 41.1945 170.893 38.6485C169.327 37.6882 168.054 36.3258 167.209 34.6955C166.319 33.0205 165.869 31.1445 165.869 29.0786C165.869 27.0128 166.353 25.1479 167.311 23.4617C168.245 21.8091 169.62 20.4356 171.287 19.4976C172.999 18.526 174.937 18.0235 176.908 18.0459C178.958 18.0682 180.817 18.5484 182.484 19.5199ZM180.524 35.5441C181.594 34.8965 182.472 33.9808 183.069 32.8753C183.689 31.714 184.004 30.4074 183.993 29.0898C184.016 27.7609 183.689 26.4544 183.069 25.2819C181.211 21.8872 176.919 20.6366 173.495 22.4791C173.427 22.5237 173.348 22.5572 173.281 22.6019C172.199 23.2496 171.321 24.1764 170.724 25.2819C170.093 26.4544 169.766 27.7609 169.789 29.0898C169.766 30.4074 170.093 31.714 170.724 32.8753C171.321 33.9696 172.211 34.8853 173.281 35.533C175.522 36.8395 178.293 36.8395 180.524 35.5441Z",
    fill: "url(#paint16_linear_9495_138227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.378 39.24C205.779 38.6817 204.528 37.9558 203.616 37.0625C203.278 36.7387 203.086 36.292 203.098 35.8342C203.086 35.22 203.39 34.6393 203.897 34.282C204.404 33.9135 204.866 33.7237 205.294 33.7237C205.824 33.7237 206.33 33.9582 206.815 34.4383C207.322 34.9967 208.076 35.4768 209.09 35.89C210.115 36.3032 211.219 36.5153 212.334 36.5042C213.855 36.5042 215.038 36.2585 215.871 35.7448C216.705 35.2312 217.133 34.5723 217.133 33.7237C217.133 32.875 216.716 32.2273 215.894 31.6801C215.072 31.133 213.664 30.6751 211.692 30.3066C206.567 29.324 204.01 27.2358 204.01 24.0309C204.01 22.7356 204.393 21.6413 205.17 20.7367C205.948 19.8322 206.961 19.1622 208.212 18.7156C209.496 18.2577 210.848 18.0344 212.211 18.0456C213.945 18.0456 215.5 18.3247 216.874 18.8831C218.248 19.4414 219.33 20.2007 220.129 21.1834C220.479 21.6078 220.648 22.0321 220.648 22.4564C220.648 22.9031 220.422 23.3163 219.972 23.6848C219.645 23.9081 219.251 24.0198 218.845 23.9974C218.147 23.9974 217.471 23.7294 216.964 23.2381C216.356 22.6686 215.635 22.2219 214.846 21.9539C214.103 21.7083 213.191 21.5742 212.12 21.5742C210.893 21.5742 209.89 21.7753 209.102 22.1884C208.313 22.6016 207.919 23.1711 207.919 23.9081C207.896 24.3771 208.043 24.8461 208.324 25.2369C208.595 25.5943 209.102 25.9293 209.845 26.2308C210.588 26.5323 211.67 26.8338 213.089 27.1241C215.995 27.7048 218.057 28.5088 219.273 29.5473C220.49 30.5746 221.098 31.9146 221.098 33.5562C221.109 34.7398 220.76 35.89 220.096 36.8727C219.431 37.8665 218.451 38.6482 217.156 39.2177C215.86 39.7872 214.306 40.0775 212.492 40.0664C210.757 40.0887 209.023 39.8095 207.378 39.24Z",
    fill: "url(#paint17_linear_9495_138227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1164 48.5978C77.1952 48.676 77.2403 48.7876 77.2403 48.8993V54.4157C77.2403 54.5273 77.1952 54.639 77.1164 54.7172C76.9474 54.8847 76.6771 54.8847 76.5194 54.7172C76.4405 54.639 76.3954 54.5273 76.3954 54.4157V50.3622L74.4016 54.3822C74.3228 54.5162 74.1876 54.5943 74.0299 54.5943C73.861 54.5943 73.7032 54.4938 73.6357 54.3375L71.6644 50.4292V54.4045C71.6644 54.5162 71.6193 54.6278 71.5405 54.706C71.3715 54.8735 71.1012 54.8735 70.9322 54.706C70.8534 54.6278 70.8083 54.5162 70.8083 54.4045V48.8881C70.8083 48.6536 70.9998 48.4638 71.2363 48.4638C71.394 48.4638 71.5405 48.5531 71.6193 48.6983L74.0637 53.5447L76.4518 48.6871C76.5644 48.475 76.8122 48.3968 77.0263 48.4973C77.06 48.5308 77.0938 48.5531 77.1164 48.5978Z",
    fill: "#2451A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6359 54.7171C82.557 54.6389 82.512 54.5272 82.512 54.4156V48.8992C82.512 48.7875 82.557 48.6759 82.6359 48.5977C82.7147 48.5195 82.8274 48.4749 82.94 48.4749H86.6573C86.7699 48.4749 86.8826 48.5084 86.9614 48.5865C87.0403 48.6647 87.0741 48.7652 87.0741 48.8769C87.0741 48.9774 87.0403 49.0779 86.9614 49.156C86.8826 49.2342 86.7699 49.2677 86.6573 49.2677H83.3681V51.2554H85.7336C85.8462 51.2554 85.9476 51.2889 86.0377 51.367C86.1954 51.5234 86.1954 51.769 86.0377 51.9254C85.9589 52.0035 85.8462 52.037 85.7336 52.037H83.3681V54.0694H86.6573C86.7699 54.0694 86.8826 54.1029 86.9614 54.1811C87.0403 54.2481 87.0741 54.3486 87.0741 54.4602C87.0741 54.5719 87.0403 54.6724 86.9614 54.7506C86.8826 54.8287 86.7699 54.8622 86.6573 54.8622H82.94C82.8274 54.8399 82.7147 54.7952 82.6359 54.7171Z",
    fill: "#2451A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0079 54.7164C91.929 54.6383 91.884 54.5266 91.884 54.4149V48.8986C91.884 48.7869 91.929 48.6752 92.0079 48.5971C92.0867 48.5189 92.1994 48.4742 92.312 48.4742H93.7989C94.3734 48.4631 94.9479 48.6082 95.4548 48.8874C95.9279 49.1554 96.3222 49.5462 96.5812 50.0152C97.1219 51.0426 97.1219 52.2709 96.5812 53.3094C96.3222 53.7896 95.9279 54.1804 95.4548 54.4373C94.9479 54.7164 94.3847 54.8504 93.7989 54.8393H92.312C92.1994 54.8393 92.0867 54.7946 92.0079 54.7164ZM93.7989 54.0911C94.227 54.1023 94.655 53.9906 95.0267 53.7784C95.3872 53.5774 95.6801 53.2759 95.8603 52.9074C96.2658 52.1146 96.2658 51.1877 95.8603 50.3949C95.6688 50.0376 95.3759 49.7361 95.0267 49.5351C94.655 49.3229 94.2382 49.2224 93.8102 49.2224H92.7513V54.0911H93.7989Z",
    fill: "#2451A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.067 54.7163C101.988 54.6382 101.943 54.5265 101.943 54.4148V48.8985C101.943 48.7868 101.988 48.6751 102.067 48.597C102.146 48.5188 102.258 48.4741 102.371 48.4741C102.596 48.463 102.788 48.6416 102.799 48.865C102.799 48.8761 102.799 48.8873 102.799 48.9096V54.426C102.799 54.5377 102.754 54.6493 102.675 54.7275C102.596 54.8057 102.484 54.8503 102.371 54.8503C102.258 54.8392 102.146 54.7945 102.067 54.7163Z",
    fill: "#2451A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.333 54.4939C108.848 54.2148 108.454 53.8016 108.184 53.3103C107.902 52.8078 107.756 52.2383 107.767 51.6576C107.756 51.0881 107.902 50.5186 108.184 50.0161C108.454 49.5247 108.848 49.1227 109.333 48.8324C109.817 48.5421 110.369 48.3857 110.943 48.3969C111.315 48.3857 111.676 48.4416 112.025 48.5644C112.363 48.6872 112.678 48.8771 112.948 49.1004C113.005 49.1339 113.05 49.1897 113.084 49.2567C113.106 49.3126 113.117 49.3796 113.117 49.4354C113.117 49.5359 113.072 49.6364 112.993 49.7034C112.915 49.7704 112.825 49.8151 112.723 49.8151C112.622 49.8151 112.52 49.7816 112.43 49.7034C112.239 49.5359 112.013 49.3907 111.777 49.2902C111.507 49.2009 111.225 49.1562 110.943 49.1674C110.527 49.1674 110.121 49.2791 109.761 49.5024C109.4 49.7257 109.107 50.0384 108.904 50.4069C108.476 51.1886 108.476 52.1378 108.904 52.9194C109.107 53.2879 109.4 53.6006 109.761 53.8239C110.11 54.0473 110.527 54.1589 110.943 54.1589C111.495 54.1478 112.025 53.9579 112.453 53.6229C112.532 53.5671 112.622 53.5336 112.723 53.5224C112.825 53.5224 112.915 53.5671 112.982 53.6341C113.05 53.7123 113.095 53.8128 113.084 53.9244C113.084 54.0361 113.039 54.1478 112.948 54.2259C112.385 54.6838 111.664 54.9406 110.932 54.9406C110.369 54.9294 109.817 54.7843 109.333 54.4939Z",
    fill: "#2451A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.917 54.4271C122.917 54.5388 122.872 54.6393 122.794 54.7175C122.715 54.7956 122.602 54.8403 122.489 54.8403C122.411 54.8403 122.32 54.818 122.253 54.7733C122.174 54.7286 122.118 54.6616 122.095 54.5835L121.633 53.4444H118.682L118.209 54.5835C118.175 54.6616 118.119 54.7286 118.04 54.7733C117.972 54.818 117.894 54.8403 117.815 54.8403C117.702 54.8403 117.589 54.7956 117.511 54.7175C117.432 54.6393 117.387 54.5276 117.387 54.4159C117.387 54.3489 117.398 54.2931 117.432 54.2261L119.741 48.7544C119.797 48.5869 119.955 48.4641 120.146 48.4641C120.327 48.4529 120.496 48.5758 120.552 48.7544L122.872 54.2373C122.906 54.3043 122.917 54.3601 122.917 54.4271ZM118.975 52.7409H121.352L120.18 49.8376L118.975 52.7409Z",
    fill: "#2451A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.592 54.7171C127.513 54.6389 127.468 54.5272 127.468 54.4156V48.8992C127.468 48.7875 127.513 48.6759 127.592 48.5977C127.671 48.5195 127.772 48.4749 127.885 48.4749C128.122 48.4749 128.313 48.6535 128.313 48.888C128.313 48.888 128.313 48.888 128.313 48.8992V53.9912H131.287C131.524 53.9912 131.715 54.1699 131.715 54.4044V54.4156C131.715 54.5272 131.67 54.6389 131.591 54.7171C131.512 54.7952 131.4 54.8399 131.287 54.8399H127.885C127.772 54.8511 127.671 54.7952 127.592 54.7171Z",
    fill: "#2451A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9495_138227",
    x1: 29.1474,
    y1: -0.00103276,
    x2: 29.1474,
    y2: 28.5504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A64F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2A64F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A64F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9495_138227",
    x1: 22.5945,
    y1: 16.882,
    x2: 24.5658,
    y2: 8.85739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0846A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1564FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9495_138227",
    x1: 22.4798,
    y1: 26.002,
    x2: 36.6804,
    y2: 7.69022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0046AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0077FF",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#00A3FF",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00CCFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#00C8FF",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#00BEFF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#00ADFF",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0094FF",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#0076FF",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0066FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9495_138227",
    x1: 44.0943,
    y1: 18.5721,
    x2: 44.0943,
    y2: 39.4936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A64F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2A64F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A64F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9495_138227",
    x1: 41.5382,
    y1: 22.5102,
    x2: 49.6179,
    y2: 24.5285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0846A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1564FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9495_138227",
    x1: 32.1757,
    y1: 22.2889,
    x2: 50.5494,
    y2: 36.7868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0046AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0077FF",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#00A3FF",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00CCFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#00C8FF",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#00BEFF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#00ADFF",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0094FF",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#0076FF",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0066FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9495_138227",
    x1: 39.88,
    y1: 43.7204,
    x2: 18.7775,
    y2: 43.7204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A64F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2A64F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A64F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9495_138227",
    x1: 35.9106,
    y1: 41.1133,
    x2: 33.9404,
    y2: 49.1391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0846A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1564FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9495_138227",
    x1: 35.9956,
    y1: 31.993,
    x2: 21.795,
    y2: 50.3058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0046AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0077FF",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#00A3FF",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00CCFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#00C8FF",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#00BEFF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#00ADFF",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0094FF",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#0076FF",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0066FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9495_138227",
    x1: 14.4437,
    y1: 39.4602,
    x2: 14.4437,
    y2: 18.5408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A64F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2A64F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A64F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9495_138227",
    x1: 17.0892,
    y1: 35.5236,
    x2: 9.00957,
    y2: 33.5041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0846A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1564FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9495_138227",
    x1: 26.3261,
    y1: 35.6834,
    x2: 8.01286,
    y2: 21.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0046AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0077FF",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#00A3FF",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00CCFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#00C8FF",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#00BEFF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#00ADFF",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0094FF",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#0076FF",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0066FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_9495_138227",
    x1: 113.895,
    y1: -19.3662,
    x2: 95.6865,
    y2: 3.00437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#367C21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#5ECB3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#66DC42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#6CE846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#6EEC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#6CE846",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#68DD42",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#61CC3D",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FC73B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_9495_138227",
    x1: 67.4378,
    y1: 29.0766,
    x2: 88.21,
    y2: 29.0766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A64F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_9495_138227",
    x1: 105.536,
    y1: 29.2505,
    x2: 127.586,
    y2: 29.2505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A64F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_9495_138227",
    x1: 143.81,
    y1: 24.4919,
    x2: 152.618,
    y2: 24.4919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A64F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_9495_138227",
    x1: 165.861,
    y1: 29.0761,
    x2: 187.911,
    y2: 29.0761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A64F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_9495_138227",
    x1: 203.098,
    y1: 29.074,
    x2: 221.104,
    y2: 29.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A64F5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9495_138227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 221.56,
    height: 58,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEolasTitle);
export default __webpack_public_path__ + "static/media/eolasTitle.4d7bc4be.svg";
export { ForwardRef as ReactComponent };